'use strict';

angular.module('app.campaignActivity')
    .directive('campaignInfluencerKpi', function () {
        return {
            restrict: 'E',
            scope: {
                kpi: '=',
            },
            templateUrl: 'app/campaign/campaignActivityPage/influencerKPI/campaignInfluencerKPI.html?app_v=deployDate'
        };
    });